import { OperationStatus } from '../BulkOperationQueue.interface';

/**
 * Common styles for action item rows based on status
 */
export const getItemStyles = (status: OperationStatus) => {
  const isFailed = status === 'failed';
  const isCompleted = status === 'completed';

  return {
    isFailed,
    isCompleted,
    container: {
      bg: isFailed ? 'pastel-1-light' : 'base-white',
    },
    text: {
      color: isFailed ? 'pastel-1-dark' : isCompleted ? 'success-700' : 'secondary-700',
    },
    borderColor: isFailed ? 'pastel-1-dark' : 'border-color',
  };
};
